(function () {
  'use strict';
  const normalize = v => String(v || '').toLocaleLowerCase('es').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const patterns = {
    dama: /\b(dama|mujer|women|woman|femenin[ao]|girl|ninos?|ninas?|kids?|junior)\b/,
    mujer: /\b(dama|mujer|women|woman|femenin[ao])\b/,
    hombre: /\b(hombre|men|man|masculin[ao]|caballero)\b/,
    camisetas: /\b(camiseta[s]?|t-shirt[s]?|tshirt[s]?|tee[s]?)\b/,
    polos: /\b(polo[s]?)\b/,
    accesorios: /\b(accesorio[s]?|gorra[s]?|bolso[s]?|cinturon(?:es)?|correa[s]?|billetera[s]?|morral(?:es)?|gafa[s]?)\b/,
    pantalones: /\b(pantalon(?:es)?|jean[s]?|denim|jogger[s]?|short[s]?)\b/
  };
  function matchCategory(text, cat) {return cat === 'all' || Boolean(patterns[cat]?.test(normalize(text)));}
  function isKid(text) {return /\b(kids?|ninos?|ninas?|infantil|junior|boy|girl)\b/.test(normalize(text));}
  function isWoman(text) {return /\b(dama|mujer|women|woman|femenin[ao])\b/.test(normalize(text));}
  function init(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    // V4: proteccion adicional cuando el tema inserta breadcrumbs fuera de la plantilla.
    document.querySelectorAll('#MainContent > .breadcrumbs, main#MainContent .breadcrumbs').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
    const state = {category:'all', brand:'all', size:'all'};
    const grid = root.querySelector('[data-products]');
    if (!grid) return;
    // Compra rápida aislada dentro de la sección SALE. Ninguna otra plantilla se modifica.
    const variantCache = new WeakMap();
    const sizeNorm = v => normalize(v).trim();
    function cardInfo(card) {
      if (variantCache.has(card)) return variantCache.get(card);
      const qb = card.querySelector('[data-quickbuy]');
      if (!qb) return null;
      let variants=[];
      try { variants=JSON.parse(qb.querySelector('[data-variant-json]')?.textContent||'[]'); } catch(e) {}
      const sizeSet=qb.querySelector('[data-size-index]');
      const sizeIndex=sizeSet?Number(sizeSet.dataset.sizeIndex):-1;
      const result={qb,variants,sizeIndex,selectedSize:null};
      variantCache.set(card,result);
      return result;
    }
    function syncQuick(card) {
      const data=cardInfo(card);
      if(!data)return;
      const {qb,variants,sizeIndex}=data;
      const otherSelectors=[...qb.querySelectorAll('select[data-quick-option-index]')];
      const matchesOther=v=>otherSelectors.every(el=>sizeNorm(v.options[Number(el.dataset.quickOptionIndex)])===sizeNorm(el.value));
      const available=variants.filter(v=>v.available);
      // Si el color seleccionado no tiene la talla filtrada, cambiar a una combinación disponible.
      let desired=data.selectedSize||(state.size!=='all'&&sizeIndex>=0?state.size:null);
      let candidates=available.filter(v=>sizeIndex<0||!desired||sizeNorm(v.options[sizeIndex])===sizeNorm(desired));
      if(!candidates.length) candidates=available;
      if(candidates.length && !candidates.some(matchesOther)) {
        const first=candidates[0];
        otherSelectors.forEach(el=>{el.value=first.options[Number(el.dataset.quickOptionIndex)];});
      }
      const eligible=available.filter(matchesOther);
      qb.querySelectorAll('[data-quick-size]').forEach(btn=>{
        const v=btn.dataset.quickSize;
        const possible=eligible.some(x=>sizeIndex>=0&&sizeNorm(x.options[sizeIndex])===sizeNorm(v));
        btn.disabled=!possible;
      });
      if(sizeIndex>=0){
        const choices=[...qb.querySelectorAll('[data-quick-size]:not(:disabled)')];
        const selected=choices.find(b=>sizeNorm(b.dataset.quickSize)===sizeNorm(desired))||choices[0];
        data.selectedSize=selected?.dataset.quickSize||null;
        qb.querySelectorAll('[data-quick-size]').forEach(btn=>{
          const active=btn===selected;btn.classList.toggle('is-selected',active);btn.setAttribute('aria-pressed',String(active));
        });
        const label=qb.querySelector('[data-chosen-size]');if(label)label.textContent=data.selectedSize?': '+data.selectedSize:'';
      }
      const variant=eligible.find(v=>sizeIndex<0||sizeNorm(v.options[sizeIndex])===sizeNorm(data.selectedSize));
      const add=qb.querySelector('[data-quick-add]');
      if(add){add.dataset.variantId=variant?.id||'';add.disabled=!variant;add.textContent=variant?'Agregar al carrito':'Agotado';}
    }
    grid.addEventListener('click',async e=>{
      const card=e.target.closest('[data-product]');
      if(!card||!grid.contains(card))return;
      const btnSize=e.target.closest('[data-quick-size]');
      if(btnSize){const data=cardInfo(card);if(!data||btnSize.disabled)return;data.selectedSize=btnSize.dataset.quickSize;syncQuick(card);return;}
      const add=e.target.closest('[data-quick-add]');
      if(!add||add.disabled)return;
      const variantId=Number(add.dataset.variantId);
      if(!variantId)return;
      const qb=card.querySelector('[data-quickbuy]');const feedback=qb.querySelector('[data-quick-feedback]');
      const oldText=add.textContent;add.disabled=true;add.textContent='Agregando…';
      try{
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:variantId,quantity:1}]})
        });
        const result=await response.json();
        if(!response.ok)throw Error(result.description||result.message||'No se pudo añadir el producto');
        if(feedback)feedback.textContent='¡Producto agregado al carrito!';
        // Sincronizar el controlador NATIVO de Eleganza (theme.js).
        // Las señales genéricas por sí solas no actualizan el popup ni sus cantidades.
        const nativeCart=window.theme && window.theme.Cart;
        if(nativeCart && typeof nativeCart.updateData==='function' && typeof nativeCart.updateCart==='function'){
          try {
            await nativeCart.updateData(); // Recupera /cart.js y actualiza currentData.
            await nativeCart.updateCart(); // Reconstruye carrito lateral y contador del encabezado.
            if(typeof nativeCart.showPopup==='function') nativeCart.showPopup();
          } catch(cartRefreshError) {
            console.warn('[Eleganza SALE] El artículo se agregó, pero falló la actualización visual del carrito.',cartRefreshError);
            if(feedback) feedback.textContent='Producto agregado. Abre el carrito para consultar tu compra.';
          }
        } else {
          // Respaldo por si el controlador todavía no se ha inicializado.
          try {
            const res=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});
            if(res.ok){
              const cart=await res.json();
              document.querySelectorAll('[data-cart-count], [data-js-cart-count-mobile]').forEach(el=>{el.textContent=cart.item_count;});
            }
          } catch(ignore) {}
          if(feedback)feedback.textContent='Producto agregado. Puedes abrir el carrito para verlo.';
        }
        // La barra Urban usa estas señales para volver a consultar el carrito.
        ['cart:updated','cart:refresh','cart:change'].forEach(name=>document.dispatchEvent(new CustomEvent(name,{detail:{source:'eleganza-sale',item:result}})));
        document.dispatchEvent(new CustomEvent('eleganza:sale:cart-added',{detail:{item:result}}));
        if(window.jQuery){window.jQuery(document).trigger('cart:refresh').trigger('cart:updated');}
      }catch(error){if(feedback)feedback.textContent=error.message||'Error al agregar. Intenta nuevamente.';}
      finally{syncQuick(card);if(add.dataset.variantId)add.textContent=oldText;}
    });
    grid.addEventListener('change',e=>{const select=e.target.closest('select[data-quick-option-index]');if(select){const card=select.closest('[data-product]');if(card){const d=cardInfo(card);if(d)d.selectedSize=null;syncQuick(card);}}});

    const count = root.querySelector('[data-result-count]');
    const empty = root.querySelector('[data-empty]');
    const loader = root.querySelector('[data-loading]');
    const groups = Array.from(root.querySelectorAll('[data-filter-group]'));
    let products = Array.from(grid.querySelectorAll('[data-product]'));
    let completed = false;
    function eligible(el, exclude) {
      return (exclude === 'brand' || state.brand === 'all' || el.dataset.brand === state.brand) &&
        (exclude === 'category' || matchCategory(el.dataset.search, state.category)) &&
        (exclude === 'size' || state.size === 'all' || normalize(el.dataset.sizes).includes('|' + normalize(state.size) + '|'));
    }
    function filterButtons() {
      groups.forEach(group => {
        const key = group.dataset.filterGroup;
        group.querySelectorAll('button[data-filter-value]').forEach(button => {
          const value = button.dataset.filterValue;
          const exists = value === 'all' || products.some(p => {
            if (!eligible(p,key)) return false;
            if (key === 'size') return normalize(p.dataset.sizes).includes('|'+normalize(value)+'|');
            if (key === 'brand') return p.dataset.brand === value;
            return matchCategory(p.dataset.search,value);
          });
          button.hidden = !exists;
        });
        const current = group.querySelector('button.is-active');
        if (current?.hidden) {
          state[key] = 'all';
          group.querySelectorAll('button').forEach(button => {
            const active = button.dataset.filterValue === 'all';
            button.classList.toggle('is-active',active);
            button.setAttribute('aria-pressed',String(active));
          });
        }
      });
    }
    function refresh() {
      filterButtons();
      let visible = 0;
      products.forEach(p => {
        const show = eligible(p);
        p.hidden = !show;
        if (show) {visible++;syncQuick(p);}
      });
      // Si Dama y Kids está activo, mostrar primero Dama y después Kids.
      if (root.dataset.campaign === 'casual' && state.category === 'dama') {
        products.filter(p=>!p.hidden).sort((a,b)=> {
          const score = p => isWoman(p.dataset.search) && !isKid(p.dataset.search) ? 0 : isKid(p.dataset.search) ? 1 : 2;
          return score(a)-score(b);
        }).forEach(el=>grid.appendChild(el));
      }
      if (count) count.textContent = visible+' '+(visible === 1?'producto':'productos')+(completed?'':' · cargando catálogo…');
      if (empty) empty.hidden = visible !== 0 || !completed;
    }
    groups.forEach(group=>group.addEventListener('click',e=>{
      const btn=e.target.closest('button[data-filter-value]');
      if (!btn || btn.hidden || !group.contains(btn)) return;
      state[group.dataset.filterGroup]=btn.dataset.filterValue;
      if (group.dataset.filterGroup==='size') products.forEach(p=>{const data=variantCache.get(p);if(data)data.selectedSize=null;});
      group.querySelectorAll('button[data-filter-value]').forEach(b=>{
        const active = b === btn;
        b.classList.toggle('is-active',active);
        b.setAttribute('aria-pressed',String(active));
      });
      refresh();
    }));
    root.querySelector('[data-reset]')?.addEventListener('click',()=>{
      Object.keys(state).forEach(key=>state[key]='all');
      groups.forEach(group=>group.querySelectorAll('button[data-filter-value]').forEach(btn=>{
        const active=btn.dataset.filterValue==='all';
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-pressed',String(active));
      }));
      refresh();
    });
    let updateProgress=()=>{};
    if (root.dataset.campaign === 'urban') {
      const message=root.querySelector('[data-progress-message]');
      const bar=root.querySelector('[data-progress-fill]');
      const track=root.querySelector('[data-progress-track]');
      const milestones=Array.from(root.querySelectorAll('.ez-sale__progress-milestones span'));
      const currency=root.dataset.currency||'COP';
      const money=cents=>new Intl.NumberFormat('es-CO',{style:'currency',currency,maximumFractionDigits:0}).format(cents/100);
      const tiers=[{limit:50000000,pct:10},{limit:70000000,pct:20},{limit:100000000,pct:30}];
      let lastCartSignature='';
      updateProgress=async()=>{
        try {
          const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});
          if(!response.ok) throw Error('cart');
          const cart=await response.json();
          lastCartSignature=JSON.stringify(cart.items.map(i=>[i.key,i.quantity,i.original_line_price]));
          const ids=new Set(products.map(p=>String(p.dataset.productId)));
          const eligibleCents=cart.items.filter(i=>ids.has(String(i.product_id))).reduce((sum,i)=>sum+i.original_line_price,0);
          const next=tiers.find(t=>eligibleCents<t.limit);
          const earned=tiers.filter(t=>eligibleCents>=t.limit).pop();
          const goal=next?.limit||100000000;
          if(message) message.textContent= next
            ? `Llevas ${money(eligibleCents)} · ${earned?`Ya alcanzaste el ${earned.pct}% OFF · `:''}Te faltan ${money(next.limit-eligibleCents)} para completar ${money(next.limit)} y obtener el ${next.pct}% OFF`
            : `¡Completaste ${money(100000000)} y alcanzaste el 30% OFF! Compras elegibles: ${money(eligibleCents)}`;
          // La última meta se ubica en el 100%; 500k en 50% y 700k en 70%.
          const pct=Math.max(0,Math.min(100,eligibleCents/100000000*100));
          if(bar) bar.style.width=pct+'%';
          if(track) track.setAttribute('aria-valuenow',String(Math.min(1000000,Math.round(eligibleCents/100))));
          milestones.forEach((m,i)=>m.classList.toggle('is-reached',eligibleCents>=tiers[i].limit));
        } catch(error) {if(message) message.textContent='No fue posible actualizar el carrito. Recarga la página para ver tu progreso.';}
      };
      ['cart:updated','cart:refresh','cart:change','cart:build','cart:success'].forEach(e=>document.addEventListener(e,updateProgress));
      window.addEventListener('pageshow',updateProgress);
      // Algunos temas no notifican cambios en el carrito lateral: revisar al cerrarlo o volver al foco.
      document.addEventListener('visibilitychange',()=>{if(!document.hidden) updateProgress();});
      let timer;
      const observer=new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(updateProgress,450);});
      const drawer=document.querySelector('[class*="cart-drawer"], [id*="CartDrawer"], .cart-sidebar');
      if(drawer) observer.observe(drawer,{childList:true,subtree:true});
    }
    async function loadRemaining() {
      let next=root.querySelector('[data-next-page]')?.href;
      const visited=new Set();
      if(loader) loader.hidden=!next;
      while(next && !visited.has(next)) {
        visited.add(next);
        try {
          const response=await fetch(next,{credentials:'same-origin'});
          if(!response.ok) throw Error('HTTP '+response.status);
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const remote=doc.querySelector('[data-ez-sale]');
          if(!remote) throw Error('No se encontró sección SALE en el siguiente lote');
          const found=Array.from(remote.querySelectorAll('[data-product]'));
          if(!found.length) break;
          found.forEach(p=>grid.appendChild(document.importNode(p,true)));
          products=Array.from(grid.querySelectorAll('[data-product]'));
          const nextPath=remote.querySelector('[data-next-page]')?.getAttribute('href');
          next=nextPath?new URL(nextPath,window.location.origin).href:null;
          refresh();
          if(root.dataset.campaign==='urban') updateProgress();
        } catch(error) {
          if(loader) {loader.hidden=false;loader.textContent='No se pudieron cargar todos los productos. Actualiza la página para reintentarlo.';}
          completed=true;refresh();return;
        }
      }
      completed=true;
      if(loader) loader.hidden=true;
      refresh();
      updateProgress();
    }
    refresh();
    loadRemaining();
  }
  function start(){document.querySelectorAll('[data-ez-sale]').forEach(init);}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start):start();
  document.addEventListener('shopify:section:load',start);
})();